// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2i6cN","large":"styles_large__3s77H","heading":"styles_heading__wt8nw","content":"styles_content__gEYNb"};